// extracted by mini-css-extract-plugin
module.exports = {"boxWrapper":"_1NKRX86J9XKTAHBUFg6UGp","box":"_1v6IRi2-6IDljqQmPAWzOK","combo":"_2gFxWPKsJVschmk1Ac2Pta","option":"_2Me97iR8WAnHZPj4L2IB_4"};